import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '@static/services/auth.service';
import { HttpService } from '@static/services/http.service';
import { MarkdownComponent } from 'ngx-markdown';

export interface IRecentChangesData {
  lastVersion: string;
  currentVersion: string;
}

@Component({
  selector: 'app-recent-changes',
  imports: [
    MatDialogModule,
    MatButtonModule,
    MarkdownComponent,
  ],
  templateUrl: './recent-changes.component.html',
  styleUrl: './recent-changes.component.scss'
})
export class RecentChangesComponent {
  public dialogRef: MatDialogRef<RecentChangesComponent> = inject(MatDialogRef<RecentChangesComponent>);
  public data: IRecentChangesData = inject(MAT_DIALOG_DATA);
  private _http: HttpService = inject(HttpService);
  private _authService: AuthService = inject(AuthService);

  public latest?: string;
  public empty?: boolean;

  constructor() {
    this.empty = false;
    this._http.getP<string>('/changelog.md', { responseType: 'text' })
      .then((data: string) => {
        this._splitChangelog(data);
      });
  }

  /**
   * Extract the relevant versions from the changelog
   *
   * @param log changelog text
   */
  private _splitChangelog(log: string): void {
    const parts = log.split(/\r?\n/);

    const displayParts = [];
    let adding = false;
    let idx = 0;
    while (idx < parts.length) {
      if (adding && parts[idx].includes(this.data.lastVersion)) break;
      if (!adding && parts[idx].startsWith("## v") && parts[idx].includes(this.data.currentVersion)) adding = true;
      if (adding) {
        if ((parts[idx].includes("[GA]") && !this._authService.isGlobalAdmin)
            || (parts[idx].includes("[SA]") && !this._authService.isSiteAdmin)) {
          idx += 1;
          continue;
        }
        displayParts.push(parts[idx]);
      }
      idx += 1;
    }

    this.latest = displayParts.join("\n");
    if (displayParts.length === 0) this.empty = true;
  }

  /**
   * Close the dialog
   */
  public close(): void {
    this.dialogRef.close(false);
  }
}
